export enum CountryCode {
    Belgium = 'BE',
    France = 'FR',
    Germany = 'DE',
    Netherlands = 'NL',
    Luxembourg = 'LU',
}
